import React, { useState } from 'react'
// import { Link } from 'react-router-dom'

import { Form, Button, Input, Toast } from 'antd-mobile'

import { useAuth } from '../../contexts/AuthContextProvider'

const Login = () => {
  const { firebaseLogin } = useAuth()
  const [loading, setLoading] = useState(false)

  const handleChange = async (formData) => {
    try {
      setLoading(true)
      const formatedEmail = formData.email.trim().toLowerCase()
      await firebaseLogin(formatedEmail, formData.password)
    } catch (error) {
      Toast.show({
        content: error.message
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Form layout='vertical' mode='card' onFinish={handleChange}>
      <Form.Item name='email' label='Email' rules={[{ required: true, message: 'Please input your Email!' }]}>
        <Input className='input-auth' type='email' placeholder='Email' />
      </Form.Item>
      <Form.Item name='password' label='Password' rules={[{ required: true, message: 'Please input your Password!' }]}>
        <Input className='input-auth' type='password' placeholder='Password' />
      </Form.Item>
      {/* <Row>
        <Col span={15}>
          <Checkbox>Remember me</Checkbox>
        </Col>
        <Col span={9}>
          <Link to='/forget-password' style={{ textDecoration: 'underline', float: 'right' }}>ลืมรหัสผ่าน</Link>
        </Col>
      </Row> */}
      <Form.Item>
        <Button block color='primary' type='submit' loading={loading}>
          <span style={{ fontSize: '16px', fontFamily: 'Roboto' }}>เข้าสู่ระบบ</span>
        </Button>
      </Form.Item>
      {/* <div style={{ textAlign: 'center', fontSize: '12px', fontFamily: 'Prompt' }}>
        <Link to='/register' style={{ textDecoration: 'underline' }}>สมัครเข้าเรียน</Link>
      </div> */}
    </Form>
  )
}

export default Login
